import { useI18n } from "i18n";
import {
  selectCurrentEvent,
  selectIsEventManager,
} from "modules/event/selectors";
import copy from "copy-to-clipboard";
import { useSelector } from "react-redux";
import { useAppDispatch } from "store/hooks";
import { Box } from "@remo-co/ui-core/src/components/Box";
import { Button, IButtonProps } from "@remo-co/ui-core/src/components/Button";
import { Tooltip } from "@remo-co/ui-core/src/components/Tooltip";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { Share as ShareIcon } from "@remo-co/ui-core/src/icons/Share";
import { addSuccessNotification } from "modules/notification/redux/notificationSlice";
import { selectIsInBroadcast } from "modules/broadcast/redux/selectors";
import { selectIsMobile } from "modules/deviceInfo";
import { useStyles } from "./styles";

const ShareEventButton = (): JSX.Element | null => {
  const { t } = useI18n();
  const appDispatch = useAppDispatch();
  const event = useSelector(selectCurrentEvent);
  const isEventManager = useSelector(selectIsEventManager);
  const isInBroadcast = useSelector(selectIsInBroadcast);
  const isMobileView = useSelector(selectIsMobile);
  const styles = useStyles({ isInBroadcast });

  if (!event) return null;

  if (event.isPrivate && !isEventManager) return null;

  const handleShare = () => {
    copy(`${window.location.origin}/e/${event.code}`);
    appDispatch(
      addSuccessNotification({
        message: t("theater:copy.event.link.success"),
        autoDismiss: 5,
      }),
    );
  };

  const defaultProps: IButtonProps = {
    color: isInBroadcast ? "gray" : "dark",
    className: styles.shareEventButton,
    onClick: handleShare,
  };

  return (
    <Tooltip title={t("theater:share.event.button.tooltip")}>
      {isMobileView ? (
        <Button
          {...defaultProps}
          isIconButton
          variant="ghost"
          data-testid="share-button"
        >
          <Typography variant="subtitle2">
            <Box display="flex" alignItems="center">
              <ShareIcon />
            </Box>
          </Typography>
        </Button>
      ) : (
        <Button {...defaultProps} variant="ghost" data-testid="share-button">
          <Typography variant="h4" className={styles.shareText}>
            {t("share.event.button")}
          </Typography>
        </Button>
      )}
    </Tooltip>
  );
};

export default ShareEventButton;
